import React, { useState } from 'react';
import {
    Button,
    alpha,
    useTheme,
    Box
} from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import WithdrawModal from '../Profile/WithdrawModal';
import { useSelector } from 'react-redux';

const WithdrawButton = ({ variant = "default" }) => {
    const theme = useTheme();
    const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
    const userData = useSelector(state => state.profile.userData);

    const buttonStyles = {
        default: {
            borderRadius: 2,
            py: 1,
            px: 3,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: `0 4px 12px ${alpha(theme.palette.success.main, 0.2)}`,
            background: `linear-gradient(45deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
            '&:hover': {
                background: `linear-gradient(45deg, ${theme.palette.success.dark}, ${theme.palette.success.main})`,
                boxShadow: `0 6px 16px ${alpha(theme.palette.success.main, 0.3)}`,
                transform: 'translateY(-1px)'
            },
            transition: 'all 0.3s ease'
        },
        outlined: {
            borderRadius: 2,
            py: 1,
            px: 3,
            textTransform: 'none',
            fontWeight: 600,
            border: `1px solid ${theme.palette.success.main}`,
            color: theme.palette.success.main,
            bgcolor: 'transparent',
            '&:hover': {
                bgcolor: alpha(theme.palette.success.main, 0.1),
                borderColor: theme.palette.success.main
            }
        },
        minimal: {
            borderRadius: 2,
            py: 0.5,
            px: 2,
            textTransform: 'none',
            fontWeight: 500,
            color: theme.palette.success.main,
            '&:hover': {
                bgcolor: alpha(theme.palette.success.main, 0.1)
            }
        }
    };

    return (
        <Box sx={{ display: 'inline-block' }}>
            <Button
                variant={variant === 'outlined' ? "outlined" : "contained"}
                startIcon={<AccountBalanceWalletIcon />}
                onClick={() => setIsWithdrawModalOpen(true)}
                sx={buttonStyles[variant]}
            >
                Withdraw Funds
            </Button>

            <WithdrawModal
                open={isWithdrawModalOpen}
                onClose={() => setIsWithdrawModalOpen(false)}
                bankAccounts={userData?.bank_accounts || []}
            />
        </Box>
    );
};

export default WithdrawButton; 